export default {
      id: "icon-menu-file-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#icon-menu-file-usage",
      toString: function () {
        return this.url;
      }
    }